<template>
  <v-container fill-height>
    <v-layout
      flex
      align-center
      justify-center
    >
      <v-card justify-center>
        <v-card-text class="justify-center text-center">
          Espere un momento
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'VSpinner'

}
</script>

<style lang="scss" scoped>
</style>
